import api from '../api'; // Importa l'istanza axios configurata da frontend/src/api.js

// --- Funzioni per l'Autenticazione ---
export const refreshToken = () => api.post('/auth/refresh-token');

// --- Funzioni per la Gestione del Layout della pagina Chi Siamo ---
export const getAboutBlocks = () => api.get('/about-blocks/');

export const createAboutBlock = (blockData) => {
  // blockData: oggetto JS con i dati del blocco (block_type, content, image_url, visible, ecc.)
  return api.post('/about-blocks/', blockData);
};

export const updateAboutBlock = (id, blockData) => {
  return api.put(`/about-blocks/${id}`, blockData);
};

export const deleteAboutBlock = (id) => api.delete(`/about-blocks/${id}`);

export const reorderAboutBlocks = (orderedIds) => api.post('/about-blocks/reorder', { block_ids: orderedIds });

// --- Contenuti del sito modenariversamenti.it ---
export const getRiversamentiBlocks = (pagina) => api.get('/riversamenti-blocks/', { params: { pagina } });

export const createRiversamentiBlock = (blockData) => api.post('/riversamenti-blocks/', blockData);

export const updateRiversamentiBlock = (id, blockData) => api.put(`/riversamenti-blocks/${id}`, blockData);

export const deleteRiversamentiBlock = (id) => api.delete(`/riversamenti-blocks/${id}`);

export const reorderRiversamentiBlocks = (orderedIds) => api.post('/riversamenti-blocks/reorder', { block_ids: orderedIds });

export const uploadRiversamentiImage = (file) => {
  const dati = new FormData();
  dati.append('file', file);
  return api.post('/upload/riversamenti-image', dati, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const uploadRiversamentiVideo = (file) => {
  const dati = new FormData();
  dati.append('file', file);
  return api.post('/upload/riversamenti-video', dati, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Esempio di funzioni API (da espandere per ogni modulo)
export const getClienti = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/clienti/?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};
export const getOriginiCliente = () => api.get('/clienti/suggerimenti/origini');
export const getOriginiOrdini = () => api.get('/utils/origini-ordini');
export const getProvinceCliente = () => api.get('/clienti/suggerimenti/province');
export const getCittaCliente = () => api.get('/clienti/suggerimenti/citta');
export const createCliente = (cliente) => api.post('/clienti/', cliente);
export const getCliente = (id) => api.get(`/clienti/${id}`);
export const updateCliente = (id, cliente) => api.put(`/clienti/${id}`, cliente);
export const deleteCliente = (id) => api.delete(`/clienti/${id}`);
export const deleteMultipleClienti = (clientIds) => api.post('/clienti/delete-multiple/', { client_ids: clientIds });
export const exportClientiCSV = (clientIds) => api.post('/clienti/export/csv', { client_ids: clientIds }, { responseType: 'blob' });
export const exportClientiExcel = () => api.post('/clienti/export/excel', {}, { responseType: 'blob' });
export const deleteAllClienti = () => api.post('/clienti/delete-all'); // Changed to POST

// Liste Desiderate Clienti
export const getListeDesiderate = (clienteId) => api.get(`/clienti/${clienteId}/liste`);
export const createListaDesiderata = (clienteId, payload) => api.post(`/clienti/${clienteId}/liste`, payload);
export const deleteListaDesiderata = (clienteId, listaId) => api.delete(`/clienti/${clienteId}/liste/${listaId}`);

// Punti Fedeltà
export const resetAllPuntiFedelta = () => api.post('/punti-fedelta/reset-all');
export const getOrdiniByCliente = (clienteId) => api.get(`/clienti/${clienteId}/ordini`);
export const getProdottiByCliente = (clienteId) => api.get(`/clienti/${clienteId}/prodotti`);
export const searchStoricoProdottiCliente = (clienteId, params) => api.get(`/clienti/${clienteId}/storico-prodotti`, { params });

export const getClienteImportColumns = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/clienti/import/columns', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const importClienti = (file, mapping) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mapping', JSON.stringify(mapping));
    return api.post('/clienti/import', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getFornitori = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/fornitori/?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};
export const createFornitore = (fornitore) => api.post('/fornitori/', fornitore);
export const getFornitore = (id) => api.get(`/fornitori/${id}`);
export const updateFornitore = (id, fornitore) => api.put(`/fornitori/${id}`, fornitore);
export const deleteFornitore = (id) => api.delete(`/fornitori/${id}`);
export const deleteMultipleFornitori = (fornitoreIds) => api.post('/fornitori/delete-multiple/', { fornitore_ids: fornitoreIds });
export const exportFornitoriCSV = (fornitoreIds) => api.post('/fornitori/export/csv', { fornitore_ids: fornitoreIds }, { responseType: 'blob' });
export const exportFornitoriExcel = () => api.post('/fornitori/export/excel', {}, { responseType: 'blob' });

export const getFornitoreImportColumns = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/fornitori/import/columns', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const importFornitori = (file, mapping) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mapping', JSON.stringify(mapping));
    return api.post('/fornitori/import', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getFilm = (skip = 0, limit = 100, sort = [], filters = null) => {
  const params: any = { skip, limit };
  if (sort && sort.length > 0) {
    params.sort = sort;
  }
  if (filters) {
    params.filters = filters;
  }
  return api.get(`/film/`, { params });
};
export const getFilmById = (id) => api.get(`/film/${id}`);
export const spostaUbicazioneMassivo = (payload) => api.post('/inventario/sposta-ubicazione-massivo', payload);
export const cercaInUbicazione = (codice, ubicazione) => api.get('/inventario/cerca-in-ubicazione', { params: { codice, ubicazione } });
export const syncFilmMirakl = (id) => api.post(`/film/${id}/sync-mirakl`);
export const updateUbicazioniFilm = (id, righe) => api.put(`/film/${id}/ubicazioni`, righe);
export const updateUbicazioniMusica = (id, righe) => api.put(`/musica/${id}/ubicazioni`, righe);
export const getUbicazioniProdotto = (tipoProdotto, id) => api.get(`/inventario/ubicazioni/${tipoProdotto}/${id}`);
export const getAltriFormatiFilm = (id) => api.get(`/film/${id}/altri-formati`);
export const getSuggerimentiFilm = (id) => api.get(`/film/${id}/suggerimenti`);
export const createFilm = (film) => {
  const isFormData = film instanceof FormData;
  return api.post('/film/', film, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const updateFilm = (id, film) => {
  const isFormData = film instanceof FormData;
  return api.put(`/film/${id}`, film, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const deleteFilm = (id) => api.delete(`/film/${id}`);
export const deleteMultipleFilms = (filmIds) => api.post('/film/delete-multiple/', { film_ids: filmIds });
export const exportFilmsCSV = (filmIds) => api.post('/film/export/csv', { film_ids: filmIds }, { responseType: 'blob' });
export const exportFilmsExcel = () => api.post('/film/export/excel', {}, { responseType: 'blob' });
export const exportFilmIBS = () => api.get('/film/export/ibs', { responseType: 'blob' });
export const exportFilmWeb = (filmIds) => api.post('/film/export/web', { film_ids: filmIds }, { responseType: 'blob' });

export const exportFilmWebFiltered = (filters = null) => {
  let url = '/export/film/web/filtered';
  if (filters) {
    url += `?filters=${filters}`;
  }
  return api.get(url, { responseType: 'blob' });
};



export const assignFilmImages = () => api.post('/film/assign-images');
export const refreshFilmImages = (maxProducts = 50, useOnlineFallback = false) => api.post('/film/refresh-images', null, { params: { max_products: maxProducts, use_online_fallback: useOnlineFallback } });



export const deleteFilmImage = (filmId) => api.delete(`/film/${filmId}/image`);
export const deleteAllFilmImages = () => api.post('/film/delete-all-images');
export const deleteAllFilms = () => api.post('/film/delete-all');

// Funzioni per i suggerimenti dei film
export const getGeneri = () => api.get('/film/suggerimenti/generi');
export const getGeneriPersonalizzati = () => api.get('/film/suggerimenti/generi-personalizzati');
export const getCaseDiProduzione = () => api.get('/film/suggerimenti/case_di_produzione');
export const getDistinctCasaDiDistribuzione = () => api.get('/film/suggerimenti/casa_di_distribuzione');
export const getUbicazioni = () => api.get('/film/suggerimenti/ubicazioni');
export const getTipiUscita = () => api.get('/film/suggerimenti/tipo_uscita');
export const getCategorie = () => api.get('/film/suggerimenti/categorie');
export const getSupporti = () => api.get('/film/suggerimenti/supporti');
export const getCondizioni = () => api.get('/film/suggerimenti/condizioni');
export const getAnni = () => api.get('/film/suggerimenti/anni');
export const getMinutaggi = () => api.get('/film/suggerimenti/minutaggi');
export const getPrezziNegozio = () => api.get('/film/suggerimenti/prezzi-negozio');
export const getPrezziIBS = () => api.get('/film/suggerimenti/prezzi-ibs');
export const getQuantita = () => api.get('/film/suggerimenti/quantita');

export const searchTmdbFilms = (query) => api.get(`/film/search-tmdb/?query=${query}`);
export const searchLocalFilms = (query) => api.get(`/film/search-local/?query=${query}`);
export const importFilmFromTmdb = (tmdbId) => api.post(`/film/import-tmdb/${tmdbId}`);
export const updateFilmFromTmdb = (filmId, tmdbId) => api.put(`/film/${filmId}/update-from-tmdb/${tmdbId}`);
export const bulkUpdateRatingsFromTmdb = (filmIds = null) => {
  const payload = filmIds ? { film_ids: filmIds } : {};
  return api.post('/film/bulk-update-ratings-from-tmdb', payload);
};

// Funzione helper per costruire URL EventSource per aggiornamento rating
export const getUpdateRatingsStreamUrl = (filmIds) => {
  const params = new URLSearchParams();
  filmIds.forEach(id => params.append('film_ids', id));
  return `${process.env.REACT_APP_API_BASE_URL}/film/update-ratings-stream/?${params.toString()}`;
};
export const generateFilmWebDescription = (filmId) => api.post(`/film/${filmId}/generate-web-description`);
export const generateEditorialBarcode = () => api.get('/film/generate-editorial-barcode');
export const generateWebDescriptions = (filmIds = null) => {
  const payload = filmIds ? { film_ids: filmIds } : {};
  return api.post('/film/generate-web-descriptions', payload);
};

export const updateGenresFromFile = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/film/import/update-genres', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// Nuova funzione per popolare l'anno mancante dei film da TMDB
export const populateSelectedFilmsFromTmdb = (filmIds) => api.post('/film/populate-selected-from-tmdb', { film_ids: filmIds });

export const scrapeIbsUrl = (url) => api.post('/film/scrape-ibs-url', { url: url });
export const scrapeDvdStore = (ean) => api.get(`/film/scrape-dvdstore/${ean}`);

export const bulkUpdateFilms = (filmIds, updates) => {
  return api.post('/film/bulk-update', { film_ids: filmIds, updates: updates });
};

export const bulkUpdateFilmsByFilter = (filters, updates) => {
    return api.post('/film/bulk-update-by-filter', { filters, updates });
};

// === CATALOGHI PDF ===
export const getCataloghi = (skip = 0, limit = 20, nome = null, stato = null, template = null, sortBy = 'created_at', sortOrder = 'desc', filters = null) => {
  let url = `/cataloghi/?skip=${skip}&limit=${limit}`;
  
  // Legacy filters for backwards compatibility
  if (nome) url += `&nome=${encodeURIComponent(nome)}`;
  if (stato) url += `&stato=${encodeURIComponent(stato)}`;
  if (template) url += `&template=${encodeURIComponent(template)}`;
  
  url += `&sort_by=${sortBy}&sort_order=${sortOrder}`;
  
  // Advanced filters
  if (filters) {
    try {
      const parsedFilters = typeof filters === 'string' ? JSON.parse(filters) : filters;
      Object.keys(parsedFilters).forEach(key => {
        const value = parsedFilters[key];
        if (typeof value === 'object' && value !== null) {
          // Handle complex filters like {in: [...]} for multi-select
          url += `&${key}=${encodeURIComponent(JSON.stringify(value))}`;
        } else {
          // Handle simple string/number filters
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });
    } catch (e) {
      console.error('Error parsing filters:', e);
    }
  }
  
  return api.get(url);
};
export const getCatalogo = (id) => api.get(`/cataloghi/${id}`);
export const createCatalogo = (catalogo) => api.post('/cataloghi/', catalogo);
export const updateCatalogo = (id, catalogo) => api.put(`/cataloghi/${id}`, catalogo);
export const deleteCatalogo = (id) => api.delete(`/cataloghi/${id}`);
export const addFilmsToCatalogo = (catalogoId, filmIds) => api.post(`/cataloghi/${catalogoId}/films`, filmIds);
export const removeFilmFromCatalogo = (catalogoId, filmId) => api.delete(`/cataloghi/${catalogoId}/films/${filmId}`);
export const reorderCatalogoFilms = (catalogoId, filmOrder) => api.put(`/cataloghi/${catalogoId}/films/reorder`, filmOrder);
export const getCatalogoFilms = (catalogoId, ordered = true) => api.get(`/cataloghi/${catalogoId}/films?ordered=${ordered}`);
export const anteprimaPdfCatalogo = (dati) => api.post('/cataloghi/anteprima-pdf', dati);
// --- Copertine DVD (copertine cartacee da elenco film del cliente) ---
export const getCopertineLotti = () => api.get('/copertine-dvd/lotti');
export const creaCopertineLotto = (nome, testo) => api.post('/copertine-dvd/lotti', { nome, testo });
export const getCopertineLotto = (id) => api.get(`/copertine-dvd/lotti/${id}`);
export const eliminaCopertineLotto = (id) => api.delete(`/copertine-dvd/lotti/${id}`);
export const aggiungiAlLotto = (id, testo) => api.post(`/copertine-dvd/lotti/${id}/aggiungi`, { testo });
export const rilanciaRicercaLotto = (id, ids = null) => api.post(`/copertine-dvd/lotti/${id}/ricerca`, { ids });
export const generaPdfLotto = (id, ids = null) => api.post(`/copertine-dvd/lotti/${id}/genera-pdf`, { ids });
export const modificaVoceCopertina = (id, dati) => api.put(`/copertine-dvd/voci/${id}`, dati);
export const eliminaVoceCopertina = (id) => api.delete(`/copertine-dvd/voci/${id}`);
export const cercaVoceCopertina = (id, dati) => api.post(`/copertine-dvd/voci/${id}/cerca`, dati);
export const scegliVoceCopertina = (id, tmdbId, tipo) => api.post(`/copertine-dvd/voci/${id}/scegli`, { tmdb_id: tmdbId, tipo });
export const getPaletteCopertine = () => api.get('/copertine-dvd/palette');
export const aggiornaLottoCopertine = (id, dati) => api.put(`/copertine-dvd/lotti/${id}`, dati);
export const completaGeneriLotto = (id) => api.post(`/copertine-dvd/lotti/${id}/completa-generi`);
export const anteprimaPdfVoce = (id) => api.post(`/copertine-dvd/voci/${id}/anteprima-pdf`);
export const caricaLocandinaVoce = (id, file) => {
  const dati = new FormData();
  dati.append('file', file);
  return api.post(`/copertine-dvd/voci/${id}/locandina`, dati, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getCatalogoOpzioni = () => api.get('/cataloghi/opzioni');
export const cercaPersoneCatalogo = (ruolo, q, soloProtagonisti = true) => api.get('/cataloghi/persone', { params: { ruolo, q, solo_protagonisti: soloProtagonisti } });
export const anteprimaCatalogo = (criteri) => api.post('/cataloghi/anteprima', criteri);
export const generateCatalogoPdf = (catalogoId, mobileLayout = false, quality = 'high') => {
  const params = new URLSearchParams();
  if (mobileLayout) params.append('mobile_layout', 'true');
  if (quality !== 'high') params.append('quality', quality);
  
  const queryString = params.toString();
  const url = `/cataloghi/${catalogoId}/generate-pdf${queryString ? `?${queryString}` : ''}`;
  
  return api.post(url);
};
export const duplicateCatalogo = (catalogoId, nuovoNome = null) => {
  let url = `/cataloghi/${catalogoId}/duplicate`;
  if (nuovoNome) url += `?nuovo_nome=${encodeURIComponent(nuovoNome)}`;
  return api.post(url);
};

// --- API per suggerimenti Film (dropdown filtri) ---
export const getSuggerimentiGeneri = () => api.get('/film/suggerimenti/generi');
export const getSuggerimentiSupporti = () => api.get('/film/suggerimenti/supporti');
export const getSuggerimentiCondizioni = () => api.get('/film/suggerimenti/condizioni');
export const getSuggerimentiRegisti = () => api.get('/film/suggerimenti/registi');
export const getSuggerimentiAttori = () => api.get('/film/suggerimenti/attori');
export const getSuggerimentiCaseFilm = () => api.get('/film/suggerimenti/case_produzione_distribuzione');


export const populateSelectedMusicaFromMusicbrainz = (musicaIds) => api.post('/musica/populate-selected-from-musicbrainz', { musica_ids: musicaIds });


export const getMusica = (skip = 0, limit = 100, sort = [], filters = null) => {
  const params: any = { skip, limit };
  if (sort && sort.length > 0) {
    params.sort = sort;
  }
  if (filters) {
    params.filters = filters;
  }
  return api.get(`/musica/`, { params });
};
export const getMusicaById = (id) => api.get(`/musica/${id}`);
export const createMusica = (musica) => {
  const isFormData = musica instanceof FormData;
  return api.post('/musica/', musica, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const updateMusica = (id, musica) => {
  const isFormData = musica instanceof FormData;
  return api.put(`/musica/${id}`, musica, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const deleteMusica = (id) => api.delete(`/musica/${id}`);
export const deleteMultipleMusica = (musicaIds) => api.post('/musica/delete-multiple/', { musica_ids: musicaIds });
export const exportMusicaCSV = (musicaIds) => api.post('/musica/export/csv', { musica_ids: musicaIds }, { responseType: 'blob' });
export const exportMusicaExcel = () => api.post('/musica/export/excel', {}, { responseType: 'blob' });
export const exportMusicaIBS = () => api.get('/export/musica/ibs', { responseType: 'blob' });
export const exportMusicaWeb = (musicaIds) => api.post('/musica/export/web', { musica_ids: musicaIds }, { responseType: 'blob' });

export const exportMusicaWebFiltered = (filters = null) => {
  let url = '/export/musica/web/filtered';
  if (filters) {
    url += `?filters=${filters}`;
  }
  return api.get(url, { responseType: 'blob' });
};

// Mirakl messages
export const getOrderMiraklMessages = (ordineId) => api.get(`/mirakl/orders/${ordineId}/messaggi`);
export const replyOrderMiraklMessage = (ordineId, threadId, message_body, recipients, tipi) => api.post(`/mirakl/orders/${ordineId}/threads/${threadId}/reply`, { message_body, recipients, tipi });
export const markAllOrderMiraklMessagesRead = (ordineId) => api.post(`/mirakl/orders/${ordineId}/messaggi/mark-read`);
export const markOrderMiraklMessageRead = (ordineId, messageId) => api.post(`/mirakl/orders/${ordineId}/messaggi/mark-read/${messageId}`);
export const getMiraklMessagesSummary = () => api.get('/mirakl/unread-messages-summary');

export const ignoreMiraklThread = (threadId) => api.post(`/mirakl/threads/${threadId}/ignore`);
export const getMiraklUnreadMessagesCount = (ordineId) => api.get(`/mirakl/orders/${ordineId}/messages/unread_count`);
export const syncMiraklOrderMessages = (ordineId) => api.post(`/mirakl/orders/${ordineId}/messages/sync`);

// Ordini marketplace in anteprima ("Da Accettare"): accetta (controlla stock, scala, accetta su Mirakl) o rifiuta
export const accettaOrdineMarketplace = (ordineId) => api.post(`/ordini/${ordineId}/marketplace/accetta`);
export const rifiutaOrdineMarketplace = (ordineId) => api.post(`/ordini/${ordineId}/marketplace/rifiuta`);
// Ordini marketplace con cliente possibile duplicato: candidati esistenti e conferma della scelta (clienteId null = tieni il cliente attuale)
export const getClienteCandidatiMarketplace = (ordineId) => api.get(`/ordini/${ordineId}/marketplace/cliente-candidati`);
export const confermaClienteMarketplace = (ordineId, clienteId) => api.post(`/ordini/${ordineId}/marketplace/cliente`, { cliente_id: clienteId });
export const getDestinatarioOrdine = (ordineId) => api.get(`/ordini/${ordineId}/destinatario`);
export const risolviDestinatarioOrdine = (ordineId, payload) => api.post(`/ordini/${ordineId}/destinatario`, payload);
export const syncPendingMarketplaceOrders = () => api.post('/ordini/marketplace/sync-pending');
// Debug / inbox endpoints
export const getMiraklDebugThreads = () => api.get('/mirakl/debug/threads');
export const replyMiraklThread = (threadId, payload) => api.post(`/mirakl/inbox/threads/${threadId}/messages`, payload);

export const assignMusicaImages = () => api.post('/musica/assign-images');
export const refreshMusicaImages = (maxProducts = 50, useOnlineFallback = false) => api.post('/musica/refresh-images', null, { params: { max_products: maxProducts, use_online_fallback: useOnlineFallback } });



export const deleteMusicaImage = (musicaId) => api.delete(`/musica/${musicaId}/image`);
export const deleteAllMusicaImages = () => api.post('/musica/delete-all-images');
export const deleteAllMusica = () => api.post('/musica/delete-all');

// Funzioni per i suggerimenti della musica
export const getArtisti = () => api.get('/musica/suggerimenti/artisti');
export const getGeneriMusica = () => api.get('/musica/suggerimenti/generi');
export const getCaseDiProduzioneMusica = () => api.get('/musica/suggerimenti/case_di_produzione');
export const getCategorieMusica = () => api.get('/musica/suggerimenti/categorie');
export const getSupportiMusica = () => api.get('/musica/suggerimenti/supporti');
export const getUbicazioniMusica = () => api.get('/musica/suggerimenti/ubicazioni');
export const getAnniMusica = () => api.get('/musica/suggerimenti/anni');
export const getCondizioniMusica = () => api.get('/musica/suggerimenti/condizioni');

export const generateMusicaWebDescription = (musicaId) => api.post(`/musica/${musicaId}/generate-web-description`);
export const generateMissingMusicaWebDescriptions = () => api.post('/musica/generate-missing-web-descriptions');


// --- MusicBrainz Integration ---
export const searchMusicBrainz = (query) => api.post('/musica/search-musicbrainz', query);
export const importMusicaFromMusicbrainz = (musicbrainzId) => api.post(`/musica/import-from-musicbrainz/${musicbrainzId}`);

// --- Discogs Integration ---
export const searchDiscogs = (query) => api.post('/musica/search-discogs', query);
export const importMusicaFromDiscogs = (discogsId) => api.post(`/musica/import-from-discogs/${discogsId}`);
export const populateSelectedMusicaFromDiscogs = (musicaIds) => api.post('/musica/populate-selected-from-discogs', { musica_ids: musicaIds });
export const searchDiscogsReleases = (query) => api.get(`/musica/search-releases?q=${encodeURIComponent(query)}`);
export const updateMusicaFromDiscogs = (musicaId, releaseId) => api.post(`/musica/${musicaId}/import-discogs/${releaseId}`);
export const getDiscogsReleaseMapped = (releaseId) => api.get(`/musica/discogs/release-details/${releaseId}`);

export const bulkUpdateMusica = (musicaIds, updates) => {
  return api.post('/musica/bulk-update', { musica_ids: musicaIds, updates: updates });
};

export const getServizi = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/servizi/?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};
export const getSuggerimentiCategorieServizi = () => api.get('/servizi/suggerimenti/categorie');
export const getSuggerimentiSupportiServizi = () => api.get('/servizi/suggerimenti/supporti');
export const createServizio = (servizio) => {
  const isFormData = servizio instanceof FormData;
  return api.post('/servizi/', servizio, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const getServizio = (id) => api.get(`/servizi/${id}`);
export const updateServizio = (id, servizio) => {
  const isFormData = servizio instanceof FormData;
  return api.put(`/servizi/${id}`, servizio, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const deleteServizio = (id) => api.delete(`/servizi/${id}`);
export const deleteMultipleServizi = (servizioIds) => api.post('/servizi/delete-multiple/', { servizio_ids: servizioIds });

// --- Funzioni per Collectibles ---
export const getCollectibles = (skip = 0, limit = 100, sort = [], filters = null) => {
  const params = {
    skip,
    limit,
    sort,
    filters: filters // Pass the object directly
  };
  return api.get('/collectibles/', { params });
};
export const createCollectible = (collectible) => {
  const isFormData = collectible instanceof FormData;
  return api.post('/collectibles/', collectible, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const getCollectible = (id) => api.get(`/collectibles/${id}`);
export const updateCollectible = (id, collectible) => {
  const isFormData = collectible instanceof FormData;
  return api.put(`/collectibles/${id}`, collectible, {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    },
  });
};
export const deleteCollectible = (id) => api.delete(`/collectibles/${id}`);
export const deleteMultipleCollectibles = (collectibleIds) => api.post('/collectibles/delete-multiple/', { collectible_ids: collectibleIds });

export const bulkUpdateCollectibles = (collectibleIds, updates) => {
  return api.post('/collectibles/bulk-update', { collectible_ids: collectibleIds, updates: updates });
};

// Funzioni per suggerimenti filtri collectibles
export const getSuggerimentiCategorieProdotto = () => api.get('/collectibles/suggerimenti/categorie_prodotto');
export const getSuggerimentiBrands = () => api.get('/collectibles/suggerimenti/brands');
export const getSuggerimentiLineeProdotto = () => api.get('/collectibles/suggerimenti/linee_prodotto');
export const getSuggerimentiLicenze = () => api.get('/collectibles/suggerimenti/licenze');
export const getSuggerimentiPersonaggi = () => api.get('/collectibles/suggerimenti/personaggi');
export const getSuggerimentiArtisti = () => api.get('/collectibles/suggerimenti/artisti');
export const getSuggerimentiMateriali = () => api.get('/collectibles/suggerimenti/materiali');



// --- Funzioni per Preventivi ---
export const getPreventivi = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/preventivi/?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
  }
  return api.get(url);
};
export const getPreventivo = (id) => api.get(`/preventivi/${id}`);
export const createPreventivo = (preventivo) => api.post('/preventivi/', preventivo);
export const updatePreventivo = (id, preventivo) => api.put(`/preventivi/${id}`, preventivo);
export const deletePreventivo = (id) => api.delete(`/preventivi/${id}`);
// includiLink (opzionale): aggiorna la scelta 'link di accettazione online' prima dell'invio. La mail porta il PDF in allegato.
export const inviaPreventivo = (id, includiLink) => api.post(`/preventivi/${id}/invia`, includiLink === undefined ? {} : { includi_link: includiLink });
export const segnaPreventivoInviato = (id) => api.post(`/preventivi/${id}/segna-inviato`);
export const accettaPreventivoManuale = (id) => api.post(`/preventivi/${id}/accetta-manuale`);
export const scaricaPdfPreventivo = (id) => api.get(`/preventivi/${id}/pdf`, { responseType: 'blob' });



export const getCorrieri = (skip = 0, limit = 100, order_by = null, direction = null, filters = null) => {
  let url = `/corrieri/?skip=${skip}&limit=${limit}`;
  if (order_by) {
    url += `&order_by=${order_by}`;
  }
  if (direction) {
    url += `&direction=${direction}`;
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};
export const createCorriere = (corriere) => api.post('/corrieri/', corriere);
export const getCorriere = (id) => api.get(`/corrieri/${id}`);
export const updateCorriere = (id, corriere) => api.put(`/corrieri/${id}`, corriere);
export const deleteCorriere = (id) => api.delete(`/corrieri/${id}`);
export const deleteMultipleCorrieri = (corriereIds) => api.post('/corrieri/delete-multiple/', { corriere_ids: corriereIds });
export const exportCorrieriCSV = (corriereIds) => api.post('/corrieri/export/csv', { client_ids: corriereIds }, { responseType: 'blob' });
export const exportCorrieriExcel = () => api.post('/corrieri/export/excel', {}, { responseType: 'blob' });

// --- Funzioni per Regole di Spedizione ---
export const getRegoleSpedizione = (corriereId) => api.get(`/regole-spedizione/?corriere_id=${corriereId}`);
export const createRegolaSpedizione = (regola) => api.post('/regole-spedizione/', regola);
export const getRegolaSpedizione = (id) => api.get(`/regole-spedizione/${id}`);
export const updateRegolaSpedizione = (id, regola) => api.put(`/regole-spedizione/${id}`, regola);
export const deleteRegolaSpedizione = (id) => api.delete(`/regole-spedizione/${id}`);

// --- Funzioni per Canoni Marketplace ---
export const getCanoniMarketplace = (skip = 0, limit = 100, order_by = null, direction = null, filters = null) => {
  let url = `/canoni-marketplace/?skip=${skip}&limit=${limit}`;
  if (order_by) {
    url += `&order_by=${order_by}`;
  }
  if (direction) {
    url += `&direction=${direction}`;
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};
export const createCanoneMarketplace = (canone) => api.post('/canoni-marketplace/', canone);
export const getCanoneMarketplace = (id) => api.get(`/canoni-marketplace/${id}`);
export const updateCanoneMarketplace = (id, canone) => api.put(`/canoni-marketplace/${id}`, canone);
export const deleteCanoneMarketplace = (id) => api.delete(`/canoni-marketplace/${id}`);
export const deleteMultipleCanoniMarketplace = (canoneIds) => api.post('/canoni-marketplace/delete-multiple/', { canone_marketplace_ids: canoneIds });
// --- Funzioni per Promozioni ---
export const getPromozioni = (skip = 0, limit = 100) => {
  return api.get(`/promozioni/?skip=${skip}&limit=${limit}`);
};

export const createPromozione = (promozioneData, immagineFile) => {
  const formData = new FormData();
  formData.append('promozione_data', JSON.stringify(promozioneData));
  if (immagineFile) {
    formData.append('immagine_file', immagineFile);
  }
  return api.post('/promozioni/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getPromozione = (id) => api.get(`/promozioni/${id}`);

export const updatePromozione = (id, promozioneData, immagineFile) => {
  const formData = new FormData();
  formData.append('promozione_data', JSON.stringify(promozioneData));
  if (immagineFile) {
    formData.append('immagine_file', immagineFile);
  }
  return api.put(`/promozioni/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deletePromozione = (id) => api.delete(`/promozioni/${id}`);
// -----------------------------------------

// Codici Sconto API
export const getCodiciSconto = (skip = 0, limit = 100, filters = {}) => {
  let url = `/codici-sconto/?skip=${skip}&limit=${limit}`;
  if (filters.usato !== undefined) url += `&usato=${filters.usato}`;
  if (filters.tipo) url += `&tipo=${filters.tipo}`;
  if (filters.codice) url += `&codice=${filters.codice}`;
  return api.get(url);
};

export const getCodiceSconto = (id) => api.get(`/codici-sconto/${id}`);

export const createCodiceSconto = (data) => api.post('/codici-sconto/', data);

export const createCodiciScontoBulk = (data) => api.post('/codici-sconto/bulk', data);

export const updateCodiceSconto = (id, data) => api.put(`/codici-sconto/${id}`, data);

export const deleteCodiceSconto = (id) => api.delete(`/codici-sconto/${id}`);
export const deleteMultipleCodiciSconto = (ids) => api.post(`/codici-sconto/delete-multiple`, { ids });

export const exportCodiciScontoCSV = (codiceIds) => {
  return api.post('/codici-sconto/export-csv', { codice_ids: codiceIds }, {
    responseType: 'blob'
  });
};

export const validateCoupon = (codice) => api.post('/codici-sconto/validate', { codice });

// Codici omaggio degli ordini marketplace (biglietti da stampare e infilare nel pacco)
export const getCodiciOmaggioDaStampare = () => api.get('/codici-sconto/omaggio/da-stampare');
export const segnaCodiciOmaggioStampati = (ids) => api.post('/codici-sconto/omaggio/segna-stampati', { ids });
export const getImpostazioniOmaggio = () => api.get('/codici-sconto/omaggio/impostazioni');
export const saveImpostazioniOmaggio = (data) => api.put('/codici-sconto/omaggio/impostazioni', data);
// -----------------------------------------

export const getBanche = (skip = 0, limit = 100, order_by = null, direction = null, filters = null) => {

  let url = `/banche/?skip=${skip}&limit=${limit}`;

  if (order_by) {

    url += `&order_by=${order_by}`;

  }

  if (direction) {

    url += `&direction=${direction}`;

  }

  if (filters) {

    url += `&filters=${filters}`;

  }

  return api.get(url);

};

export const createBanca = (banca) => api.post('/banche/', banca);

export const getBanca = (id) => api.get(`/banche/${id}`);
export const updateBanca = (id, banca) => api.put(`/banche/${id}`, banca);
export const deleteBanca = (id) => api.delete(`/banche/${id}`);
export const deleteMultipleBanche = (bancaIds) => api.post('/banche/delete-multiple/', { banca_ids: bancaIds });
export const exportBancheCSV = (bancaIds) => api.post('/banche/export/csv', { client_ids: bancaIds }, { responseType: 'blob' });
export const exportBancheExcel = () => api.post('/banche/export/excel', {}, { responseType: 'blob' });

// Funzioni per gli ordini (più complesse, da implementare)
export const getOrdini = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/ordini/?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};
export const createOrdine = (ordine) => api.post('/ordini/', ordine);
export const getOrdine = (id) => api.get(`/ordini/${id}`);
export const ricalcolaPromoOrdine = (id) => api.get(`/ordini/${id}/ricalcola-promo`);
export const updateOrdine = (id, ordine) => api.put(`/ordini/${id}`, ordine);
export const exportOrdinePdf = (id) => api.get(`/ordini/${id}/download-pdf`, { responseType: 'blob' });
export const splitOrder = (orderId, detailIds) => api.post(`/ordini/${orderId}/evadi-parzialmente`, { detail_ids: detailIds });
export const deleteOrdine = (id) => api.delete(`/ordini/${id}`);
export const deleteMultipleOrdini = (ordineIds) => api.post('/ordini/delete-multiple/', { ordine_ids: ordineIds });
export const archiveOrdiniPdfs = (ordineIds) => api.post('/ordini/archive-pdfs', { ordine_ids: ordineIds });
export const exportOrdiniCSV = (ordineIds) => api.post('/ordini/export/excel', { ordine_ids: ordineIds }, { responseType: 'blob' });  // esporta i selezionati in Excel
export const exportOrdiniExcel = () => api.post('/ordini/export/excel', {}, { responseType: 'blob' });
export const exportPacklinkCSV = (ordineIds) => api.post('/ordini/export-packlink-csv', { ordine_ids: ordineIds }, { responseType: 'blob' });
export const exportPaccofacileCSV = (ordineIds) => api.post('/ordini/export-paccofacile-csv', { ordine_ids: ordineIds }, { responseType: 'blob' });
export const creaSpedizionePaccofacile = (ordineId) => api.post(`/ordini/${ordineId}/paccofacile/spedizione`);
export const creaSpedizioniPaccofacile = (ordineIds) => api.post('/ordini/paccofacile/spedizioni', { ordine_ids: ordineIds });
export const sincronizzaSpedizioniPaccofacile = () => api.post('/ordini/paccofacile/sincronizza');
export const creaSpedizioniPacklink = (ordineIds) => api.post('/ordini/packlink/spedizioni', { ordine_ids: ordineIds });
export const sincronizzaSpedizioniPacklink = () => api.post('/ordini/packlink/sincronizza');
export const getOrdiniDaNotificareConsegna = () => api.get('/ordini/notifiche-consegna/da-inviare');
export const getMessaggioTrackingOrdine = (ordineId) => api.get(`/ordini/${ordineId}/messaggio-tracking`);
export const inviaNotificheConsegnaBulk = (ordineIds) => api.post('/ordini/notifiche-consegna/invia-bulk', { ordine_ids: ordineIds });
export const scaricaEtichettePaccofacile = (ordineIds) => api.post('/ordini/paccofacile/etichette', { ordine_ids: ordineIds }, { responseType: 'blob' });
export const getListaEvasione = (ordineIds = [], sort_by = null, sort_direction = null) => {
  let url = '/ordini/lista_evasione';
  const params = new URLSearchParams();
  if (ordineIds.length > 0) {
    params.append('ordine_ids', ordineIds.join(','));
  }
  if (sort_by) {
    params.append('sort_by', sort_by);
  }
  if (sort_direction) {
    params.append('sort_direction', sort_direction);
  }
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  return api.get(url);
};

// motivo ({ motivo_rimborso, note_rimborso }) e' obbligatorio quando newStatus e' "Rimborsato"
export const bulkUpdateOrdiniStatus = (ordineIds, newStatus, motivo = null) => {
  return api.put('/ordini/bulk_update_status', {
    ordine_ids: ordineIds,
    new_status: newStatus,
    ...(motivo || {}),
  });
};

// Modifica multipla di pagamento/corriere/banca/note: i campi assenti restano invariati
export const bulkUpdateOrdiniFields = (ordineIds, fields) => {
  return api.put('/ordini/bulk_update_fields', { ordine_ids: ordineIds, ...fields });
};

// Clienti con rimborsi precedenti: avviso su nuovi ordini, storico con motivi, decisione evadi/rifiuta
export const getAvvisiRimborsiCount = () => api.get('/ordini/avvisi-rimborsi/count');

// Pagina Abbandoni: pagamenti online non completati e carrelli lasciati sul sito
export const getAbbandoni = (giorni = 30) => api.get(`/admin/abbandoni?giorni=${giorni}`);
export const inviaPromemoriaPagamento = (ordineId) => api.post(`/admin/abbandoni/pagamenti/${ordineId}/promemoria`);
export const segnaPagamentoContattato = (ordineId) => api.post(`/admin/abbandoni/pagamenti/${ordineId}/contattato`);
export const inviaPromemoriaCarrello = (carrelloId) => api.post(`/admin/abbandoni/carrelli/${carrelloId}/promemoria`);
export const segnaCarrelloContattato = (carrelloId) => api.post(`/admin/abbandoni/carrelli/${carrelloId}/contattato`);
export const getSuggerimentiNoteRimborso = () => api.get('/ordini/suggerimenti/note-rimborso');
export const getRimborsiPerCliente = (clienteId) => api.get(`/ordini/rimborsi-per-cliente/${clienteId}`);
export const setMotivoRimborso = (ordineId, motivo) => api.put(`/ordini/${ordineId}/motivo-rimborso`, motivo);
export const decisioneRimborsiOrdine = (ordineId, decisione) => api.post(`/ordini/${ordineId}/decisione-rimborsi`, { decisione });

export const exportTrackingMarketplace = (ordineIds) => api.post('/export/tracking/marketplace', { ordine_ids: ordineIds }, { responseType: 'blob' });

export const getStatiOrdine = () => api.get('/ordini/suggerimenti/stati');
export const getOriginiOrdine = () => api.get('/ordini/suggerimenti/origini');

export const createFatturaElettronica = (ordineId) => {
  return api.post(`/ordini/${ordineId}/crea_fattura`);
};

export const getFatturaPreview = (ordineId) => {
  return api.get(`/ordini/${ordineId}/preview_fattura`);
};

export const getMovimentiMagazzino = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/magazzino/movimenti?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};

export const deleteMovimentoMagazzino = (movimentoId) => {
    return api.delete(`/magazzino/movimenti/${movimentoId}`);
};

export const deleteMovimentiMagazzino = (movimentoIds) => {
    return api.delete('/magazzino/movimenti', { data: { movimento_ids: movimentoIds } });
};

export const resendConfirmationEmail = (ordineId) => {
    return api.post(`/ordini/${ordineId}/resend-confirmation-email`);
};


export const createMovimentoMagazzino = (movimento) => api.post('/magazzino/movimenti', movimento);

export const searchProductForInbound = (itemSearch) => api.post('/magazzino/ricerca-prodotto-per-carico', itemSearch);
export const createInboundMovimenti = (inboundRequest) => api.post('/magazzino/carico', inboundRequest);



export const getDatiAzienda = () => api.get('/dati-azienda');

export const saveDatiAzienda = (formData) => {
  const data = new FormData();
  for (const key in formData) {
    if (formData[key] !== null && formData[key] !== undefined) {
      data.append(key, formData[key]);
    }
  }
  return api.post('/dati-azienda/', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Unified Search for Order Items
export const searchItems = (params) => api.get(`/search-items/`, { params });

// --- Funzioni per Layout di Stampa ---
export const getLayouts = (skip = 0, limit = 100) => api.get(`/layouts/?skip=${skip}&limit=${limit}`);
export const getLayoutsByModulo = (modulo) => api.get(`/layouts/?modulo=${modulo}`);
export const getLayout = (id) => api.get(`/layouts/${id}`);
export const createLayout = (layout) => api.post('/layouts/', layout);
export const updateLayout = (id, layout) => api.put(`/layouts/${id}`, layout);
export const deleteLayout = (id) => api.delete(`/layouts/${id}`);
export const getAvailableFields = () => api.get('/modules/available-fields');
export const generatePdf = (layoutId, recordIds) => api.post('/layouts/generate-pdf', { layout_id: layoutId, record_ids: recordIds }, { responseType: 'blob' });

// --- Funzioni per la Gestione del Layout della Homepage ---
export const getHomepageBlocks = () => api.get('/layout/homepage-blocks');

export const createHomepageBlock = (blockData, imageFile, mobileImageFile) => {
    const formData = new FormData();
    formData.append('block_data', JSON.stringify(blockData));
    if (imageFile) {
        formData.append('image_file', imageFile);
    }
    if (mobileImageFile) {
        formData.append('mobile_image_file', mobileImageFile);
    }
    return api.post('/layout/homepage-blocks/', formData);
};

export const updateHomepageBlock = (id, blockData, imageFile, mobileImageFile) => {
    const formData = new FormData();
    formData.append('block_data', JSON.stringify(blockData));
    if (imageFile) {
        formData.append('image_file', imageFile);
    }
    if (mobileImageFile) {
        formData.append('mobile_image_file', mobileImageFile);
    }
    return api.put(`/layout/homepage-blocks/${id}`, formData);
};

export const uploadSlideImage = (file) => {
    const formData = new FormData();
    formData.append('image_file', file);
    return api.post('/layout/homepage-blocks/upload-slide-image', formData);
};

export const deleteHomepageBlock = (id) => api.delete(`/layout/homepage-blocks/${id}`);
export const reorderHomepageBlocks = (orderedIds) => api.post('/layout/homepage-blocks/reorder', { ordered_ids: orderedIds });


// --- Funzioni di Utilità ---
export const getCapInfo = (cap) => api.get(`/utils/cap-info/${cap}`);

// --- Funzioni di Autenticazione ---
export const getGoogleAuthStatus = () => api.get('/auth/google/status');

// --- Funzioni per Google Calendar ---
export const createCalendarEvent = (eventData) => api.post('/calendar/events', eventData);

export const getCalendarEvents = (timeMin = null, timeMax = null) => {
    let url = '/calendar/events';
    const params = new URLSearchParams();
    if (timeMin) {
        params.append('time_min', timeMin.toISOString());
    }
    if (timeMax) {
        params.append('time_max', timeMax.toISOString());
    }
    if (params.toString()) {
        url += `?${params.toString()}`;
    }
    return api.get(url);
};


// --- Funzioni per Google Tasks ---
export const getTaskLists = () => api.get('/tasks/lists');
export const getTasksInList = (listId) => api.get(`/tasks/lists/${listId}/tasks`);
export const createTaskInList = (listId, taskData) => api.post(`/tasks/lists/${listId}/tasks`, taskData);
export const updateTaskInList = (listId, taskId, taskData) => api.put(`/tasks/lists/${listId}/tasks/${taskId}`, taskData);



// --- Funzioni per Contabilità / Fatture Passive ---

export const getFatturePassive = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/contabilita/fatture_passive?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};

export const updateFatturaPassiva = (fatturaId, updateData) => {
  return api.patch(`/contabilita/fatture_passive/${fatturaId}`, updateData);
};

export const exportFatturePassiveExcel = (filters = null) => {
  let url = `/contabilita/fatture_passive/export-excel`;
  if (filters) {
    url += `?filters=${filters}`;
  }
  return api.get(url, { responseType: 'blob' });
};

export const registraFatturaPassivaFirefly = (fatturaId, payload) =>
  api.post(`/contabilita/fatture_passive/${fatturaId}/registra-firefly`, payload);

export const annullaRegistrazioneFatturaFirefly = (fatturaId) =>
  api.delete(`/contabilita/fatture_passive/${fatturaId}/registra-firefly`);

export const syncFatturePassive = (date_from = null) => {
  let url = '/contabilita/sync_fatture_passive';
  if (date_from) {
    url += `?date_from=${date_from}`;
  }
  return api.post(url);
};

export const exportFattureEmesseExcel = (filters = null) => {
  let url = `/contabilita/fatture_emesse/export-excel`;
  if (filters) {
    url += `?filters=${filters}`;
  }
  return api.get(url, { responseType: 'blob' });
};

export const getFattureEmesse = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/contabilita/fatture_emesse?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};

export const refreshFatturaSdiStatus = (fatturaId) => {
  return api.put(`/contabilita/fatture_emesse/${fatturaId}/refresh_sdi_status`);
};

export const reinviaFattura = (fatturaId) => {
  return api.post(`/contabilita/fatture_emesse/${fatturaId}/reinvia`);
};

export const getOrdiniDaFatturare = (skip = 0, limit = 100, sort = [], filters = "{}", onlyVatCustomer = false) => {
    return api.get('/ordini/da-fatturare', { // L'endpoint corretto è in ordini, non in contabilita
        params: { 
            skip, 
            limit, 
            sort,
            filters,
            only_vat_customer: onlyVatCustomer 
        }
    });
};

export const createRicevuta = (ordineId) => {
  return api.post(`/ordini/${ordineId}/crea_ricevuta`);
};

export const createRicevuteBulk = (ordineIds) => {
  return api.post('/ordini/crea-ricevute-bulk', { ordine_ids: ordineIds });
};

export const getRicevute = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/contabilita/ricevute/?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};

export const getRicevuta = (id) => api.get(`/contabilita/ricevute/${id}`);

// Restituiscono il file (copia d'archivio resta sul server): PDF singolo o zip di più ricevute
export const downloadRicevutaPdf = (id) => api.get(`/contabilita/ricevute/${id}/download`, { responseType: 'blob' });
export const downloadRicevuteZip = (ids) => api.post('/contabilita/ricevute/download-zip', { ids }, { responseType: 'blob', timeout: 0 });

export const annullaRicevuta = (id, motivo) => {
  return api.post(`/contabilita/ricevute/${id}/annulla`, { motivo });
};

export const exportRicevuteExcel = (filters) => {
  let url = '/contabilita/ricevute/export/excel';
  if (filters) {
    url += `?filters=${encodeURIComponent(filters)}`;
  }
  return api.get(url, { responseType: 'blob' });
};

export const getRegistroCorrispettivi = (skip = 0, limit = 100, sort = [], filters = null) => {
  let url = `/contabilita/registro_corrispettivi/?skip=${skip}&limit=${limit}`;
  if (sort && sort.length > 0) {
    sort.forEach(sortParam => {
      url += `&sort=${encodeURIComponent(sortParam)}`;
    });
  }
  if (filters) {
    url += `&filters=${filters}`;
  }
  return api.get(url);
};

export const exportRegistroCorrispettiviExcel = (filters) => {
  let url = '/contabilita/registro_corrispettivi/export/excel';
  if (filters) {
    url += `?filters=${encodeURIComponent(filters)}`;
  }
  return api.get(url, { responseType: 'blob' });
};

export const createFattureBulk = (ordineIds) => {
  return api.post('/contabilita/crea_fatture_bulk', { ordine_ids: ordineIds });
};

export const getFattureBulkPreview = (ordineIds) => {
  return api.post('/contabilita/preview_fatture_massa', { ordine_ids: ordineIds });
};

// --- Funzioni per Integrazione Mirakl ---
export const getMiraklOrders = (states, start_date = null, end_date = null) => {
  const params = new URLSearchParams();
  if (states && states.length > 0) {
    params.append('states', states.join(','));
  }
  if (start_date) {
    params.append('start_date', start_date);
  }
  if (end_date) {
    params.append('end_date', end_date);
  }
  return api.get(`/mirakl/orders?${params.toString()}`);
};

export const getMiraklOfferDetails = (shopSku) => {
  return api.get(`/mirakl/offers?shop_sku=${encodeURIComponent(shopSku)}`);
};

export const updateMiraklOffer = (updateData) => {
  return api.put('/mirakl/offers/update', updateData);
};

export const shipMiraklOrder = (orderId, shipData) => {
  return api.post(`/mirakl/orders/${orderId}/ship`, shipData);
};

export const acceptMiraklOrder = (orderId) => {
  return api.post(`/mirakl/orders/${orderId}/accept`);
};

export const importMiraklOrders = async (orderIds) => {
  return await api.post('/mirakl/import-orders', { order_ids: orderIds });
};

export const bulkSyncMiraklOffers = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/mirakl/offers/sync-bulk', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};



export const massUpdateAllMiraklOffers = () => {
  return api.post('/mirakl/offers/mass-update-all');
};

export const getMiraklOffersMassUpdateStatus = (importId) => {
  return api.get(`/mirakl/offers/sync-bulk/status/${importId}`);
};






// --- Backup Database ---
export const backupDatabase = () => api.post('/backup/database', {}, { responseType: 'blob' });

// --- Funzioni per Standard Events ---
export const getStandardEvents = () => api.get('/standard-events/');
export const createStandardEvent = (eventData) => api.post('/standard-events/', eventData);
export const updateStandardEvent = (id, eventData) => api.put(`/standard-events/${id}`, eventData);
export const deleteStandardEvent = (id) => api.delete(`/standard-events/${id}`);
// --- Funzioni per l'Automazione Agenda Calendario ---1
export const generateDailyCalendarSummary = () => api.post('/calendar/events/generate-daily-summary');
export const generatePendingCalendarSummary = () => api.post('/calendar/events/generate-pending-summary');

export const exportFilmWebTotal = () => {
  return api.get('/export/film/web/total', { responseType: 'blob' });
};

export const exportMusicaWebTotal = () => {
  return api.get('/export/musica/web/total', { responseType: 'blob' });
};

// --- Funzioni per Email Templates ---
export const getEmailTemplates = (skip = 0, limit = 100) => api.get(`/email-templates/?skip=${skip}&limit=${limit}`);
export const getEmailTemplate = (id) => api.get(`/email-templates/${id}`);
export const createEmailTemplate = (template) => api.post('/email-templates/', template);
export const updateEmailTemplate = (id, template) => api.put(`/email-templates/${id}`, template);
export const deleteEmailTemplate = (id) => api.delete(`/email-templates/${id}`);
export const getGlobalEmailPlaceholders = () => api.get('/email-templates/placeholders');

// --- Funzioni per Contabilità Manuale ---
export const getFireflyAccounts = (accountType = '') => {
  let url = '/accounting/accounts';
  if (accountType) {
    url += `?account_type=${accountType}`;
  }
  return api.get(url);
};

export const getFireflyAccountMapping = () => api.get('/accounting/firefly-mapping');
export const createFireflyAccountMapping = (mappingData) => api.post('/accounting/firefly-mapping', mappingData);
export const updateFireflyAccountMapping = (mappingId, mappingData) => api.put(`/accounting/firefly-mapping/${mappingId}`, mappingData);

export const createManualTransaction = (transactionData) => api.post('/accounting/transactions', transactionData);
export const getAccountingDashboard = (startDate = null, endDate = null) => {
  let url = '/accounting/dashboard';
  const params = new URLSearchParams();
  if (startDate) {
    params.append('start_date', startDate);
  }
  if (endDate) {
    params.append('end_date', endDate);
  }
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  return api.get(url);
};

export const recalculateRegistroCorrispettivi = (startDate, endDate) => {
  return api.post('/contabilita/recalculate-registro-corrispettivi', {
    start_date: startDate,
    end_date: endDate,
  });
};

// --- Funzioni per Documenti Legali ---
export const uploadLegalDocument = (documentType, title, file) => {
  const formData = new FormData();
  formData.append('title', title);
  formData.append('file', file);
  // NON impostare manualmente Content-Type, Axios lo fa da solo con FormData
  return api.post(`/legal-documents/${toBackendLegalType(documentType)}/upload`, formData);
};

const toBackendLegalType = (documentType) =>
  documentType === 'terms_and_conditions' ? 'termini_e_condizioni' : documentType;

export const getLegalDocument = (documentType) => api.get(`/legal-documents/${toBackendLegalType(documentType)}`);

export const downloadLegalDocument = (documentType) => api.get(`/legal-documents/download/${toBackendLegalType(documentType)}`, { responseType: 'blob' });

// --- Repricing IBS ---
export const getCompetitivePrice = (ean, condizione, costoAcquisto = null) => api.post('/mirakl/repricing/competitive-price', { ean, condizione, costo_acquisto: costoAcquisto });

// --- Impostazioni prezzi (ricarico IBS + spedizione sito) ---
export const getImpostazioniPrezzi = () => api.get('/impostazioni/prezzi/');
export const getSpedizioneSito = () => api.get('/impostazioni/prezzi/spedizione-sito');
export const updateSpedizioneSito = (payload) => api.put('/impostazioni/prezzi/spedizione-sito', payload);
export const updatePercentualeIbs = (ibsMarkupPercentuale, ibsMarkupFisso = 0, ricalcolaEsistenti = false, extra = {}) =>
  api.put('/impostazioni/prezzi/ibs', { ibs_markup_percentuale: ibsMarkupPercentuale, ibs_markup_fisso: ibsMarkupFisso, ricalcola_esistenti: ricalcolaEsistenti, ...extra });

export const updateLegalDocumentContent = (documentType, title, content) => {
  return api.post(`/legal-documents/${toBackendLegalType(documentType)}/content`, {
    title: title,
    content: content,
  });
};

// --- Beni Ammortizzabili ---
export const getCespiti = (stato) => {
  let url = '/cespiti/';
  if (stato) url += `?stato=${stato}`;
  return api.get(url);
};

export const creaCespite = (data) => api.post('/cespiti/', data);

export const aggiornaCespite = (id, data) => api.patch(`/cespiti/${id}`, data);

export const eliminaCespite = (id) => api.delete(`/cespiti/${id}`);

export const getPianoCespite = (id) => api.get(`/cespiti/${id}/piano`);

export const getQuoteAnno = (anno) => api.get(`/cespiti/quote-anno?anno=${anno}`);

export const getAliquotePredefinite = () => api.get('/cespiti/aliquote-predefinite');

export const exportRegistroAmmortizzabiliExcel = (anno) =>
  api.get(`/cespiti/export/excel?anno=${anno}`, { responseType: 'blob' });

// --- Report Annuale Unico SP ---
export const getReportAnnuale = (anno) =>
  api.get(`/report-annuale/?anno=${anno}`);

export const getSociSAS = () =>
  api.get('/report-annuale/soci');

export const aggiornaSocioSAS = (id, data) =>
  api.patch(`/report-annuale/soci/${id}`, data);

export const exportReportExcel = (anno) =>
  api.get(`/report-annuale/export/excel?anno=${anno}`, { responseType: 'blob' });

export const exportReportPdf = (anno) =>
  api.get(`/report-annuale/export/pdf?anno=${anno}`, { responseType: 'blob' });

// --- Prima Nota ---
export const getPrimaNota = (anno, tipo, skip = 0, limit = 200) => {
  let url = `/prima-nota/?skip=${skip}&limit=${limit}`;
  if (anno) url += `&anno=${anno}`;
  if (tipo) url += `&tipo=${tipo}`;
  return api.get(url);
};

export const creaScritturaContabile = (data) =>
  api.post('/prima-nota/', data);

export const aggiornaScritturaContabile = (id, data) =>
  api.patch(`/prima-nota/${id}`, data);

export const eliminaScritturaContabile = (id) =>
  api.delete(`/prima-nota/${id}`);

export const getRiepilogoPrimaNota = (anno) =>
  api.get(`/prima-nota/riepilogo?anno=${anno}`);

// --- Scadenzario Fiscale ---
export const getScadenzario = (anno) =>
  api.get(`/scadenzario/?anno=${anno}`);

export const getScadenzeFiscali = (anno) =>
  api.get(`/scadenzario/fiscali/?anno=${anno}`);

export const creaScadenzaFiscale = (data) =>
  api.post('/scadenzario/fiscali/', data);

export const aggiornaScadenzaFiscale = (id, data) =>
  api.patch(`/scadenzario/fiscali/${id}`, data);

export const eliminaScadenzaFiscale = (id) =>
  api.delete(`/scadenzario/fiscali/${id}`);

export const generaScadenzeAnno = (anno) =>
  api.post(`/scadenzario/fiscali/genera-anno?anno=${anno}`);

// --- Liquidazione IVA ---
export const getLiquidazioniIva = (anno) => {
  const params = anno ? `?anno=${anno}` : '';
  return api.get(`/liquidazione-iva/${params}`);
};

export const calcolaLiquidazioneIva = (anno, trimestre) =>
  api.post('/liquidazione-iva/calcola', { anno, trimestre });

export const aggiornaLiquidazioneIva = (id, data) =>
  api.patch(`/liquidazione-iva/${id}`, data);

export const eliminaLiquidazioneIva = (id) =>
  api.delete(`/liquidazione-iva/${id}`);

export const sincronizzaRegistroCassa = (anno) =>
  api.post(`/liquidazione-iva/registro-cassa/sincronizza?anno=${anno}`);

export const getRegistroCassa = (anno, tipo, skip = 0, limit = 200) => {
  let url = `/liquidazione-iva/registro-cassa/?anno=${anno}&skip=${skip}&limit=${limit}`;
  if (tipo) url += `&tipo=${tipo}`;
  return api.get(url);
};

export const getRiepilogoCassa = (anno) =>
  api.get(`/liquidazione-iva/registro-cassa/riepilogo?anno=${anno}`);

export default api;
